import { render } from "./AppToDo.vue?vue&type=template&id=4149314d&ts=true"
import script from "./AppToDo.vue?vue&type=script&lang=ts"
export * from "./AppToDo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__